import { maintenanceModeGuard } from '@/router/guards/maintenanceModeGuard.ts';
import { createRouter, createWebHistory } from 'vue-router';
import { activationGuard } from './guards/activationGuard';
import { authenticationGuard } from './guards/authenticationGuard';
import { installationGuard } from './guards/installationGuard';
import { permissionGuard } from './guards/permissionGuard';
import { createRoutes } from './routes';
import { eulaGuard } from './guards/eulaGuard';

// Try to avoid to import this router directly and use `const router = useRouter()` instead

export const routerInstance = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [],
});

const routes = createRoutes(routerInstance);
for (const r of routes) {
  routerInstance.addRoute(r);
}

routerInstance.beforeEach(activationGuard);
routerInstance.beforeEach(installationGuard);
routerInstance.beforeEach(maintenanceModeGuard);
routerInstance.beforeEach(authenticationGuard);
routerInstance.beforeEach(permissionGuard(routerInstance));
routerInstance.beforeEach(eulaGuard);
